import { render, staticRenderFns } from "./CustomerInterface.vue?vue&type=template&id=5ddb49ce&scoped=true&"
import script from "./CustomerInterface.vue?vue&type=script&lang=js&"
export * from "./CustomerInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb49ce",
  null
  
)

component.options.__file = "CustomerInterface.vue"
export default component.exports